/* Examples
  maskCellPhone(4933333333)    => (49) 3333-3333
  maskCellPhone(49933333333)   => (49) 93333-3333
*/

export default function maskCellPhone(phone) {
  let number = phone.replace(/[^\d]/g, '');
  if (number.length === 10) {
    number = number.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (number.length === 11) {
    number = number.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  return number;
}
